import { IAllAdminRequestsData, IAllAdminRequestsResponse } from '../types';

/**
 * It will format raw response data the of `fetchAllAdminRequestsList` API call.
 */
export function formatAllAdminRequestsResponse(
  responseData: IAllAdminRequestsResponse['data']
): IAllAdminRequestsData {
  const requests = responseData.map((item) => ({
    id: item._id,
    name: item.name,
    createdAt: item.created_At,
    updatedAt: item.updated_At,
  }));

  return { requests };
}
